import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '../../redux/Slices/modalSlice';
import AIInsightsPanel from '../AI/AIInsightsPanel';
import AICardSuggestions from '../AI/AICardSuggestions';
import TextToTasksParser from '../AI/TextToTasksParser';

const AIFeatureModal = () => {
    const dispatch = useDispatch();
    const { modalData } = useSelector(state => state.modal);
    
    const handleClose = () => {
        dispatch(closeModal());
    };

    const handleTasksCreated = (tasks) => {
        // Handle task creation logic here
        handleClose();
    };

    const handleSuggestionSelect = (suggestion) => {
        // Handle suggestion selection logic here
        handleClose();
    };

    if (!modalData) return null;

    const { featureType, boardId, boardTitle } = modalData;

    const renderFeature = () => {
        switch (featureType) {
            case 'AIInsights':
                return <AIInsightsPanel boardId={boardId} />;
            case 'CardSuggestions':
                return (
                    <AICardSuggestions
                        boardId={boardId}
                        boardTitle={boardTitle}
                        onSuggestionSelect={handleSuggestionSelect}
                        onClose={handleClose}
                    />
                );

            case 'TextToTasksParser':
                return (
                    <TextToTasksParser
                        boardId={boardId}
                        boardTitle={boardTitle}
                        onTasksCreated={handleTasksCreated}
                        onClose={handleClose}
                    />
                );
            default:
                return <div>Feature not found</div>;
        }
    };

    return renderFeature();
};

export default AIFeatureModal;
